import type { DeckCard } from './types'

export function getAllocatedQuantity(
  deckCards: DeckCard[],
  collectionItemId: number,
  excludedDeckId?: number,
) {
  return deckCards.reduce(
    (total, entry) =>
      entry.collectionItemId === collectionItemId &&
      entry.deckId !== excludedDeckId
        ? total + entry.quantity
        : total,
    0,
  )
}

export function getAvailableQuantity(
  ownedQuantity: number,
  deckCards: DeckCard[],
  collectionItemId: number,
  excludedDeckId?: number,
) {
  return Math.max(
    0,
    ownedQuantity -
      getAllocatedQuantity(deckCards, collectionItemId, excludedDeckId),
  )
}
